import { BitkitIconComponent } from '@bitrise/bitkit-v2';
import { ReactNode } from 'react';

export type ArtifactDevice = {
  deviceIdentifier: string;
  owner?: {
    username: string;
  };
  title?: string;
};

export type Artifact = {
  allowedTestDevices?: {
    associated: ArtifactDevice[];
    nonAssociated: ArtifactDevice[];
  };
  appleDeviceFamiliesText?: string[];
  artifactMeta?: {
    appInfo: any;
    installType?: string;
    fileSizeBytes?: string;
  };
  artifactType: string;
  build: {
    id: string;
    slug: string;
    triggeredWorkflow: string;
  };
  distributionType: string;
  downloadUrl: string;
  expiresAt: string | null;
  fileSizeBytes: number;
  id: number;
  slug: string;
  isExpired: boolean;
  isInstallable: boolean;
  isPublicPageEnabled?: boolean;
  isIntermediateFile: boolean;
  notifiedEmails: string[];
  notifiedUsers: [
    {
      email: string;
      username: string;
    },
  ];
  publicInstallPageUrl?: string;
  title: string;
  canBeInstalledOnDevice: boolean;
  enrollUrl: string;
  isDeviceRegistered: boolean;
  installUrl?: string;
};

export type AppInfo = {
  description?: ReactNode;
  key: string;
  value: ReactNode;
};

export type DecoratedArtifactDevice = {
  name?: string;
  udid?: string;
};

export type DecoratedArtifactDevices = {
  userCount: number;
  deviceCount: number;
  users: { [key: string]: DecoratedArtifactDevice[] };
};

export type DecoratedArtifact = {
  allowedTestDevices: DecoratedArtifactDevices;
  appInfo: AppInfo[];
  build: {
    id: string;
    slug: string;
    triggeredWorkflow: string;
  };
  canBeInstalledOnDevice: boolean;
  distributionType: string;
  downloadUrl: string;
  enrollUrl: string;
  expiresAt: string | null;
  extension: string;
  extensionIconType: BitkitIconComponent;
  fileSizeBytes: number;
  id: number;
  slug: string;
  installUrl?: string | null;
  isDeviceRegistered: boolean;
  isExpired: boolean;
  isIntermediateFile: boolean;
  contentType: 'installable' | 'text' | 'image' | undefined;
  isPublicPageEnabled: boolean;
  metadata: {
    installType?: string;
  };
  notifiedEmails: string[];
  publicInstallPageUrl: string;
  title: string;
  type: string;
  version: string;
  size: string;
};

export const IMAGE_EXTENSIONS = ['jpg', 'png'];
export const TEXT_EXTENSIONS = ['html', 'json', 'log', 'plist', 'txt', 'xml', 'md'];
